
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Capa_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 50 50","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M35.9 33.7l7-7.1 7.1-7-7.1-7.1-7 7.1-7.1 7-3.8 3.8 7.1 7.1z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M17.6 23l-7-7h-.1l-3.4-3.5L0 19.6 3.5 23v.1l7 7 7.4 7.4 7.1-7.1z"}})])
          )
        }
      }
    